import {
  atom,
  useAtom,
  useAtomValue,
} from 'jotai';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import {
  useEffect,
  useMemo,
} from 'react';

const FullScreenLoading = dynamic(() =>
  import('@/components/comm/FullScreenLoading'),
{
  ssr: false,
  loading: () => null,
});

const inRouteChangingAtom = atom(false);

export const useInRouteChanging = () => useAtomValue(inRouteChangingAtom);

export const useProgressRouteChange = () => {
  const router = useRouter();
  const [inRouteChanging, setInRouteChanging] = useAtom(inRouteChangingAtom);

  const events = useMemo(() => router.events, [router.events]);

  useEffect(() => {
    const setInRouteChangingTrue = setInRouteChanging.bind(null, true);
    const setInRouteChangingFalse = setInRouteChanging.bind(null, false);

    events.on('routeChangeStart', setInRouteChangingTrue);
    events.on('routeChangeComplete', setInRouteChangingFalse);
    events.on('routeChangeError', setInRouteChangingFalse);

    return () => {
      events.off('routeChangeStart', setInRouteChangingTrue);
      events.off('routeChangeComplete', setInRouteChangingFalse);
      events.off('routeChangeError', setInRouteChangingFalse);
    };
  }, [events, setInRouteChanging]);

  return <FullScreenLoading show={inRouteChanging} />;
};

export const inRouteChangingAtomRetrieveForTest = () => inRouteChangingAtom;
